import styled from 'styled-components';
import { highlightStatusList } from './PaymentsTabServices';

function textColorFromStatus(props) {
  switch (String(props.colorStatus).toLowerCase()) {
    case highlightStatusList[1]: // paid
      return props.theme.color.successGreen;
    case highlightStatusList[2]: // cancel
      return props.theme.color.error;
    default:
      return props.theme.color.text;
  }
}

const Table = styled.table`
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
`;

const HeaderRow = styled.tr`
  background: ${props => props.theme.color.background};
  border-bottom: 1px solid ${props => props.theme.color.border};
  th {
    color: ${props => props.theme.color.label};
    width: 24%;
    padding: 15px 17px;
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    border-left: 1px solid ${props => props.theme.color.border};
  }
  th:first-child {
    width: 180px;
    border-left: none;
  }
`;

const BodyRow = styled.tr`
  border-bottom: ${props => (!props.hideBottomBorder ? '1px' : 0)} solid
    ${props => props.theme.color.border}; 
  td {
    width: 24%;
    color: ${props => textColorFromStatus(props)};
    font-weight: normal;
    text-align: left;
    border-left: 1px solid ${props => props.theme.color.border};
    font-size: 16px;
    padding: 13px 17px;
    overflow: hidden;
    text-overflow: ellipsis;    
  }
  td:first-child {
    width: 180px;
    border-left: none;
  }
`;

const TimeLine = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${props => props.theme.color.label};
`;

export default {
  Table,
  BodyRow,
  HeaderRow,
  TimeLine
};
